import {TreeNode, UpmEntityType} from '../types'

type NodeOfType<T extends UpmEntityType> = Extract<TreeNode, {itemType: T}>

export function getSubNodesByUpmType<T extends UpmEntityType>(
  root: TreeNode,
  nodeId: string,
  itemType: T
): NodeOfType<T>[] {
  const result: NodeOfType<T>[] = []

  function findAndCollect(node: TreeNode, found = false): void {
    if (found) {
      if (node.itemType === itemType) {
        result.push(node as NodeOfType<T>)
      }
      node.children?.forEach((child: TreeNode) => findAndCollect(child, true))
      return
    }

    if (node.upmId === nodeId) {
      findAndCollect(node, true)
      return
    }

    node.children?.forEach((child: TreeNode) => findAndCollect(child, false))
  }

  findAndCollect(root)
  return result
}
